import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { EuetsUsersParams } from "@/api/types"

export const euetsUsersKey = ["products", "euets", "users"] as const

export function euetsUsersOptions(params: EuetsUsersParams = {}) {
	return queryOptions({
		queryKey: [...euetsUsersKey, params] as const,
		queryFn: () =>
			GET("/api/v1/euets/users", {
				params: { query: params },
			}),
		placeholderData: keepPreviousData,
	})
}

export function useEuetsUsers(params: EuetsUsersParams = {}) {
	return useQuery(euetsUsersOptions(params))
}
